

import FilloNavbar from "../components/FilloNavbar";
import HeroHeader from "../components/HeroHeader";
import KpiStrip from "../pages/dashboard/DashboardKPI.jsx";
import TaskKpiStrip from "../components/Tasks/TaskKpiStrip.jsx";
import ProjectKpiStrip from "../components/Projects/ProjectKpiStrip.jsx";
import LeaveKpiStrip from "../components/Leaves/LeaveKpiStrip.jsx";
import ExpenseKpiStrip from "../components/Expenses/ExpenseKpiStrip.jsx";
import InventoryKpiStrip from "../components/Inventory/InventoryKpiStrip.jsx";
import { Outlet, useLocation } from "react-router-dom";
import { motion } from "framer-motion";
import ScrollToTop from "../components/ScrollToTop.jsx";

export default function DashboardLayout() {
  const location = useLocation();
  const isPayroll = location.pathname.startsWith("/payroll");
  const isTasksPage = location.pathname.startsWith("/tasks");
  const isProjectsPage =
    location.pathname.startsWith("/projects") ||
    location.pathname.startsWith("/apps");
  const isLeavesPage = location.pathname.startsWith("/leaves");
  const isExpensesPage = location.pathname.startsWith("/expenses");
  const isInventoryPage = location.pathname.startsWith("/inventory");

  const isDocumentPage = location.pathname.includes("document");
  const isGalleryPage = location.pathname.startsWith("/gallery");
  const isScreenshotsPage = location.pathname.startsWith("/screenshots");
  const isGrievancePage = location.pathname.startsWith("/grievance");
  const isProfilePage = location.pathname.startsWith("/profile");
  const isUserProfilePage = location.pathname.startsWith("/users");
  const isEmployeesPage = location.pathname.startsWith("/employees");
  const hideKpisOnMobile = isDocumentPage || isGalleryPage || isScreenshotsPage || isGrievancePage || isProfilePage || isUserProfilePage || isEmployeesPage;

  return (
    <div className="min-h-screen bg-[#12082F]">
      <FilloNavbar />

      {!isPayroll && (
        <>
          <HeroHeader />
          <div className={hideKpisOnMobile ? "hidden md:block w-full" : "w-full"}>
            {isTasksPage ? (
              <TaskKpiStrip />
            ) : isProjectsPage ? (
              <ProjectKpiStrip />
            ) : isLeavesPage ? (
              <LeaveKpiStrip />
            ) : isExpensesPage ? (
              <ExpenseKpiStrip />
            ) : isInventoryPage ? (
              <InventoryKpiStrip />
            ) : (
              <KpiStrip />
            )}
          </div>
        </>
      )}

      <motion.div
        id="page-content"
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className={isPayroll ? "" : `
          max-w-[1400px]
          mx-auto
          mt-6 sm:mt-6 md:mt-[-90px]
          bg-white/90
          backdrop-blur-xl
          rounded-3xl
          shadow-2xl
          shadow-[#12082F]/60
          p-4 sm:p-6
          relative
        `}
      >
        <Outlet />
      </motion.div>
    </div>
  );
}


